module.exports = __webpack_public_path__ + "static/img/6.1275f57.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/2/1/zh/6.png
// module id = q6C3
// module chunks = 0